export const colors = {
	black: '#000',
	bronze: '#b7995a',
	white: '#fff',
};
